<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div
      v-if="!lists.length"
      class="spinner-loader"
    >
      <sync-loader />
      Loading...
    </div>
    <div v-if="lists.length">
      <div class="points-list-container">
        <div v-for="list, index in lists">
          <div
            class="list"
            @click="toggleCheck(index)"
          >
            <input type="checkbox"
              ref="index"
              v-model="lists[index].checked"
            />
                <b style="padding-left:20px;">{{ list.tablabel }}</b>
            <template>
              <div class="list-name" style="padding-left:10px">
                Name: {{ list.name }}
              </div>
              <div class="list-name" style="padding-left:10px">
                Region: {{ list.region }}
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="subject-container">
        <div class="subject">
          <center><b>Message Details</b></center>
        </div>
        <b>Subject:</b><br><br>
        <input
          v-model="subject"
          type="text"
          class="input is-small"
        ><br><br>
        <div class="body">
          <b>Message Body:</b><br><br>
          <froala
            v-model="emailText"
            :config="config"
            :tag="'textarea'"
          />
        </div>
        <br><br>
        <button
          class="sendEmail is-pulled-right button is-info primary"
          :disabled="canSubmit"
          @click="sendEmail"
        >
          Send Email
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .sendEmail {
    position: relative;
    top: -25px;
  }
  .subject-container {
    background-color: #F8F8F8;
    padding:20px;
    margin-top:10px;
    margin-bottom: 10px;
  }
  .subject {
    background-color: #F3F3F3;
    margin-top: 0px;
    padding: 10px;
    color: #454545;
    margin-bottom: 8px;
    font-weight: bold;
    border-radius: 13px;
    border: 1px solid #000;
    box-shadow: 3px 3px 3px 0px #454545;
  }

  .list-name {
    margin-left: 25px;
  }
  .points-list-container {
    background-color: #909090;
    padding:15px;
  }
  .list {
    cursor:pointer;
    background-color: #F8F8F8;
    margin-top: 0px;
    padding: 10px;
    color: #454545;
    margin-bottom: 8px;
    font-weight: bold;
    border-radius: 13px;
  }
</style>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import PrettyCheckbox from 'pretty-checkbox-vue'
  export default {
    name: 'ToolsEmailList',
    components: {
    },
    props: ['user', 'token'],
    data () {
      return {
        lists: [],
        subject: '',
        config: {
          key: 'GPD2tA17B2A2C1A1B1sqyI-7cB-22C-16seD2zuvc1A6B5A4D3A3B2B2G3A4A3==',
          imageUploadParam: 'file',
          imageUploadURL: 'https://rest.ahlpoker.com/image/upload',
          imageUploadParams: {
            id: 'my_editor',
            token: ''
          },
          imageUploadMethod: 'POST',
          imageMaxSize: 5 * 1024 * 1024,
          imageAllowedTypes: ['jpeg', 'jpg', 'png'],
            imageManagerLoadMethod: 'GET',
          imageManagerLoadURL: 'https://rest.ahlpoker.com/image/getlist',
          imageManagerDeleteURL: 'https://rest.ahlpoker.com/image/delete',
          events: {
            'froalaEditor.image.loaded': (e, editor, $img) => {
              this['_data'].images.push($img[0].src)
            },
            'froalaEditor.image.removed': (e, editor, $img) => {
              let index = this['_data'].images.find((image) => {
                return image === $img[0].src
              })
              this['_data'].images.splice(index, 1)
            }
          }
        },
        emailText: '',
      }
    },
    computed: {
      canSubmit: function() {
        let isChecked = false
        this.lists.forEach((x) => {
          if (x.checked === true) {
            isChecked = true
          }
        })
        return !(this.subject !== '' && isChecked && this.emailText !== '')
      }
    },
    created () {
      if (!this.user || !this.user.isHost) this.$router.push({name: 'FourZeroFour'})
    },
    mounted() {
      this.getAvailableLists()
    },
    methods: {
      toggleCheck(index) {
        this.lists[index].checked = !this.lists[index].checked
      },
      sendEmail() {
        let checkedLists = []
        for (var i = 0; i < this.lists.length; i++) {
          if (this.lists[i].checked === true) {
            checkedLists.push({name: this.lists[i].name, region: this.lists[i].region})
          }
        }
        this.$axios({
          method: 'POST',
          url: '/admin/lists/email',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token,
            lists: checkedLists,
            emailText: this.emailText,
            subject: this.subject,
          }
        })
          .then((res) => {
            if (res.data.message) {
              this.$emit('message',
                {
                  showDialog: true,
                  error: res.data.error,
                  message: res.data.message
                })
              if (!res.data.error) {
                this.emailText = ''
                this.lists.forEach((x) => {
                  x.checked = false
                })
                this.subject = ''
                alert('Email sent successfully')
              } else {
                alert('An error occurred. Please try again. Error: ' + res.data.message)
              }
            }
          })
          .catch((error) => {
            this.$emit('message',
              {
                showDialog: true,
                error: true,
                message: error
              })
            alert('An error occurred')
          })
      },
      getAvailableLists() {
        this.$axios({
          method: 'POST',
          url: '/admin/lists/get',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token,
          }
        })
          .then((res) => {
            for (var i = 0; i < res.data.length; i++) {
              res.data[i].checked = false
            }
            this.lists = res.data
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }
  }
</script>
